import { useMutation, useQueryClient } from "@tanstack/react-query";
import Clients from "core/api-clients";
import { IUpdateUserRequestModel } from "@lib/types";
import { useStateContext } from "state";

type UpdateUserMutationParam = {
  userId: number;
  body: IUpdateUserRequestModel;
};

const useUpdateUser = () => {
  const queryClient = useQueryClient();
  const state = useStateContext();

  const updateUserMutation = useMutation({
    mutationFn: ({ userId, body }: UpdateUserMutationParam) =>
      Clients.ManagementBackend.Users.update(userId, body),
    onSuccess: () => {
      queryClient.invalidateQueries(["listUsers", state.tokens?.user_id]);
    },
  });
  return updateUserMutation;
};

export default useUpdateUser;
